import { useEffect, useRef, useState } from "react";

interface UseCountdownReturn {
  timeLeft: number;
  isRunning: boolean;
  start: () => void;
  pause: () => void;
  reset: () => void;
}

export function useCountdown(initialSeconds: number): UseCountdownReturn {
  const [timeLeft, setTimeLeft] = useState<number>(initialSeconds);
  const [isRunning, setIsRunning] = useState<boolean>(true);

  // Explicitly type the interval ref to handle browser/Node environment variations
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const start = (): void => {
    if (timeLeft > 0) setIsRunning(true);
  };

  const pause = (): void => {
    setIsRunning(false);
  };

  const reset = (): void => {
    if (timerRef.current) clearInterval(timerRef.current);
    setTimeLeft(initialSeconds);
    setIsRunning(true);
  };
  useEffect(() => {
    if (isRunning) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            if (timerRef.current) clearInterval(timerRef.current);
            setIsRunning(false);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [isRunning]);

  return { timeLeft, isRunning, start, pause, reset };
}
